import Section from "./Section";
import Group69 from "../../../assets/Group69.png";
import Group67 from "../../../assets/Group67.png";
import Group68 from "../../../assets/Group68.png";

const Features = () => {
  return (
    <>
      <Section
        serial="first"
        bgColor="#FFFFFF"
        text="Streamline canteen operations and cut down food waste"
        imgSrc={Group69}
      />
      <Section
        serial="second"
        bgColor="#E4FFEF"
        text="Transform canteen management and realize significant savings"
        imgSrc={Group67}
      />
      <Section
        serial="third"
        bgColor="#FFFFFF"
        text="Upgrade canteen with our innovative waste reduction and order automation tools"
        imgSrc={Group68}
      />
    </>
  );
};

export default Features;